"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postDistributorFlashOrder = void 0;
const routes_1 = require("../../routes");
const postDistributorFlashOrder = (client) => async (params, payload) => {
    const url = routes_1.ENDPOINTS.POST_PARTNER_FLASH_ORDER.applyParams({ distributorId: params.distributorId });
    const response = await client.post(url, payload, {
        headers: {
            'Content-Type': 'application/json',
            'x-beneficiary-id': params.beneficiaryId,
        },
    });
    return response.data;
};
exports.postDistributorFlashOrder = postDistributorFlashOrder;
